import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-terminos-modal',
  templateUrl: './terminos-modal.component.html',
  styleUrls: ['./terminos-modal.component.sass'],
})
export class TerminosModalComponent {
  constructor(
    public dialogRef: MatDialogRef<TerminosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public response: boolean
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  firmar() {
    this.dialogRef.close(true);
  }
}
